import DocumentPage from '@components/documents/DocumentPage'

import dbConnect from 'db/dbConnect'
import useUrlSeo from 'src/seo/server/useUrlSeo'

export default function Page ({ seo }) {
    return <DocumentPage kind="zgloszenie" seo={seo} />
}

export async function getServerSideProps (context) {
    await dbConnect()
    // poradnik i FAQ pod formularzem są w kodzie (components/documents/content) — pliki z reguły SEO nie trafiają do strony
    const { articleFile, faqFile, ...seo } = await useUrlSeo({ context, resolvedUrl: '/zgloszenie-sprzedazy-zbycia-nabycia-pojazdu-samochodu-auta' }) // eslint-disable-line no-unused-vars
    return { props: { seo } }
}
